import type { BoxProps as ChakraBoxProps } from '@chakra-ui/react';

export interface BoxProps extends ChakraBoxProps {}

export const BoxDefaultProps: BoxProps = {};
